import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadUserSyncPermissions } from '../../modules/App/AppActions';
import { getUserSyncPermissions } from '../../modules/App/AppReducer';
import Progressbar from '../progress-bar';
import PermissionTable from './permission-table';

class CheckUserSyncPermission extends Component {
  constructor(props) {
    super(props);
    const loaded = props.permissions !== undefined;

    this.state = {
      loaded,
      loadError: false,
      error: null,
    };
    if (!loaded) {
      this.props.dispatch(loadUserSyncPermissions(props.organization._id, props.user._id))
        .then(
          () => {
            this.setState({ loaded: true });
          },
          (e) => {
            const message = e.data && e.data.message ? e.data.message : e.statusText;
            this.setState({ loadError: true, error: message });
          },
        );
    }
  }

  render() {
    const { loaded, loadError, error } = this.state;
    const { permissions, showPermissionTable, showErrors, organization } = this.props;
    if (loadError) {
      return (
        <div className="alert alert-danger">
          {error}
        </div>
      );
    }
    if (!loaded || !permissions) {
      return (
        <div>
          <p />
          <Progressbar />
          <p />
          <p className="text-muted">One moment please, checking CRM permissions...</p>
        </div>
      );
    }
    const { hasError, hasWarning } = permissions;
    if (hasError) {
      return (
        <div>
          <PermissionTable permissions={permissions.permissions} organization={organization} />
          {showErrors && <p className="alert alert-danger">Please fix the permission errors above before syncing your CRM data.</p>}
        </div>
      );
    }
    return (
      <div>
        {(hasWarning || showPermissionTable) && <PermissionTable permissions={permissions.permissions} organization={organization} />}
        {this.props.children}
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  return {
    permissions: getUserSyncPermissions(state, ownProps.user._id),
  };
}

CheckUserSyncPermission.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired,
  organization: PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired,
  permissions: PropTypes.shape({
    hasError: PropTypes.bool,
    hasWarning: PropTypes.bool,
    permissions: PropTypes.shape({}),
  }),
  children: PropTypes.node,
  showPermissionTable: PropTypes.bool,
  showErrors: PropTypes.bool,
};

CheckUserSyncPermission.defaultProps = {
  children: null,
  showPermissionTable: false,
  showErrors: true,
};

export default connect(mapStateToProps)(CheckUserSyncPermission);
